/* Gluca Water Filter funnel tracking for the store pages (homepage, product page, mini cart).
   Sends events to Klaviyo with the same anonymous visitor id and ad info as the articles,
   so a reader can be followed from article to offer to checkout in one session. */
(function () {
  var script = document.currentScript;
  var company = script && script.getAttribute('data-company');
  if (!company || !window.fetch) { window.gwfTrack = function () {}; return; }

  var UTM_KEYS = ['utm_source', 'utm_campaign', 'utm_content', 'h'];
  var params = new URLSearchParams(window.location.search);
  var stored = {};
  try { stored = JSON.parse(sessionStorage.getItem('gwfUtm') || '{}') || {}; } catch (e) { stored = {}; }
  var utm = {};
  UTM_KEYS.forEach(function (k) { utm[k] = params.get(k) || stored[k] || ''; });
  try { sessionStorage.setItem('gwfUtm', JSON.stringify(utm)); } catch (e) { /* storage blocked */ }

  var anonId = null;
  try { anonId = sessionStorage.getItem('taAnonId'); } catch (e) { /* storage blocked */ }
  if (!anonId) {
    anonId = 'ta-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    try { sessionStorage.setItem('taAnonId', anonId); } catch (e) { /* storage blocked */ }
  }

  var ref = document.referrer || '';
  var fromArticle = /\/pages\/[^/?#]+/.test(ref) && ref.indexOf(window.location.host) !== -1;
  var base = {
    page: window.location.pathname,
    from_article: fromArticle ? ref.replace(/^.*\/pages\//, '').replace(/[?#].*$/, '') : '',
    ad: utm.h,
    utm_source: utm.utm_source,
    utm_campaign: utm.utm_campaign,
    utm_content: utm.utm_content,
    device: window.innerWidth < 760 ? 'mobile' : 'desktop'
  };
  var count = 0;

  window.gwfTrack = function (metric, props) {
    count += 1;
    var payload = {
      data: {
        type: 'event',
        attributes: {
          properties: Object.assign({}, base, props || {}),
          unique_id: anonId + '-' + Date.now().toString(36) + '-s' + count,
          time: new Date().toISOString(),
          metric: { data: { type: 'metric', attributes: { name: metric } } },
          profile: { data: { type: 'profile', attributes: { anonymous_id: anonId } } }
        }
      }
    };
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' },
        body: JSON.stringify(payload)
      }).catch(function () { /* tracking must never break the page */ });
    } catch (e) { /* tracking must never break the page */ }
  };

  window.gwfTrack('Store Page Viewed', {});

  document.addEventListener('DOMContentLoaded', function () {
    var offer = document.getElementById('gwf-offer');
    if (offer && window.location.hash === '#gwf-offer') {
      // Arrived from an article button that lands directly on the offer
      window.gwfTrack('Offer Viewed', { via: 'article link' });
    } else if (offer && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          window.gwfTrack('Offer Viewed', {});
          io.disconnect();
        }
      }, { threshold: 0.3 });
      io.observe(offer);
    }
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.name !== 'id' || !input.closest || !input.closest('#gwf-offer')) return;
      var card = input.closest('.gwf-tier');
      var name = card ? (card.querySelector('.g3-tier__name, .gwf-tier__name') || card).textContent : input.value;
      window.gwfTrack('Bundle Selected', { bundle: String(name).replace(/\s+/g, ' ').trim().slice(0, 60), variant_id: input.value });
    });

    if (offer) trackStoreBehavior();
  });

  /* Store page behavior: how far shoppers scroll, which sections they see, what they tap, and where they leave. */
  var SECTIONS = [
    ['#gwf-offer .g3-tiers', 'Bundles'],
    ['#gwf-pain', 'Why it can\'t wait'],
    ['[data-gwf-buy]', 'Add to cart button'],
    ['#gwf-why', 'Check your filter'],
    ['#gwf-questions', 'Questions'],
    ['#gwf-stories', 'Our story'],
    ['#gwf-reviews', 'Reviews'],
    ['#gwf-timeline', 'Timeline'],
    ['#gwf-compare', 'Us vs them'],
    ['#gwf-gifts', 'Free gifts'],
    ['#gwf-choose', 'Choose my bundle'],
    ['.g3-final', 'Final offer'],
    ['footer', 'Footer']
  ];
  var DEPTH_MARKS = [25, 50, 75, 100];
  var TIME_MARKS = [10, 30, 60, 120, 300];

  function sectionOf(el) {
    for (var i = SECTIONS.length - 1; i >= 0; i -= 1) {
      var box = el.closest && el.closest(SECTIONS[i][0]);
      if (box) return SECTIONS[i][1];
    }
    if (el.closest && el.closest('[data-gwf-gallery], .g3-gal, [data-gwf-thumbs]')) return 'Gallery';
    if (el.closest && el.closest('#gwf-offer')) return 'Buy box';
    if (el.closest && el.closest('header, .header-wrapper')) return 'Header';
    if (el.closest && el.closest('.gmc, cart-drawer')) return 'Mini cart';
    return 'Other';
  }

  function trackStoreBehavior() {
    var start = Date.now();
    var engagedMs = 0;
    var visibleSince = document.visibilityState === 'visible' ? start : null;
    var maxDepth = 0;
    var sentDepth = {};
    var sentTime = {};
    var seen = [];
    var lastSection = 'Buy box';
    var galleryMax = 1;
    var exited = false;

    function engagedSeconds() {
      var ms = engagedMs + (visibleSince ? Date.now() - visibleSince : 0);
      return Math.round(ms / 1000);
    }

    // Scroll depth of the whole page
    var ticking = false;
    function checkDepth() {
      ticking = false;
      var doc = document.documentElement;
      var total = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var pct = Math.min(100, Math.round((window.scrollY / total) * 100));
      if (pct > maxDepth) maxDepth = pct;
      DEPTH_MARKS.forEach(function (mark) {
        if (!sentDepth[mark] && pct >= (mark === 100 ? 97 : mark)) {
          sentDepth[mark] = true;
          window.gwfTrack('Store Scroll Depth', { depth: mark, seconds: engagedSeconds() });
        }
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(checkDepth); }
    }, { passive: true });

    // Sections reached (when a section's top passes the middle of the screen)
    if ('IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var name = en.target.getAttribute('data-gwf-sec');
          lastSection = name;
          if (seen.indexOf(name) === -1) {
            seen.push(name);
            window.gwfTrack('Store Section Reached', { section: name, order: seen.length, seconds: engagedSeconds() });
          }
        });
      }, { rootMargin: '0px 0px -50% 0px', threshold: 0 });
      SECTIONS.forEach(function (pair) {
        var el = document.querySelector(pair[0]);
        if (el) { el.setAttribute('data-gwf-sec', pair[1]); sio.observe(el); }
      });
    }

    // Engaged time (only while the tab is visible)
    var timer = window.setInterval(function () {
      var secs = engagedSeconds();
      TIME_MARKS.forEach(function (mark) {
        if (!sentTime[mark] && secs >= mark) {
          sentTime[mark] = true;
          window.gwfTrack('Store Time Spent', { seconds: mark, max_depth: maxDepth, section: lastSection });
        }
      });
      if (secs >= TIME_MARKS[TIME_MARKS.length - 1]) window.clearInterval(timer);
    }, 2000);

    // Gallery: how many photos they swipe through
    var gallery = document.querySelector('[data-gwf-gallery]');
    if (gallery) {
      gallery.addEventListener('scroll', function () {
        var w = gallery.clientWidth || 1;
        var idx = Math.round(gallery.scrollLeft / w) + 1;
        if (idx > galleryMax) galleryMax = idx;
      }, { passive: true });
    }

    // Taps on links, buttons and question toggles anywhere on the page
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('a, button, summary, label');
      if (!el) return;
      if (el.matches('[data-gwf-buy]')) return; // add to cart has its own event
      var label = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
      window.gwfTrack('Store Click', {
        label: label,
        href: el.getAttribute('href') || '',
        section: sectionOf(el),
        seconds: engagedSeconds(),
        depth: maxDepth
      });
    }, true);

    // One summary event when they leave or switch away
    function sendExit(how) {
      if (exited) return;
      exited = true;
      window.gwfTrack('Store Exit', {
        how: how,
        seconds_engaged: engagedSeconds(),
        max_depth: maxDepth,
        last_section: lastSection,
        sections_seen: seen.join(' > '),
        gallery_photos_seen: galleryMax
      });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        if (visibleSince) { engagedMs += Date.now() - visibleSince; visibleSince = null; }
        sendExit('hidden');
      } else {
        if (!visibleSince) visibleSince = Date.now();
        exited = false; // they came back; send a fresh summary next time they leave
      }
    });
    window.addEventListener('pagehide', function () { sendExit('left'); });

    checkDepth();
  }
})();
